import { forwardRef } from 'react';
import { type ComponentProps } from 'react';
import { msg } from '@gonfalon/messages/msg';
import { Pressable, Tag, TagGroup, TagList } from '@launchpad-ui/components';

import { HealthCheckIcon } from '../HealthCheckIcon';
import type { HealthCheckOverallStatus } from '../types';

import styles from '../HealthCheck.module.css';

const textMap: Record<HealthCheckOverallStatus, string> = {
  waiting: 'Health check waiting',
  loading: 'Health check waiting',
  pass: 'Healthy',
  fail: 'Health errors',
  warning: 'Health warnings',
  error: 'Health check failed to load',
  'partial-error': 'Health check failed to load partially',
};

const variantMap: Record<HealthCheckOverallStatus, ComponentProps<typeof Tag>['variant']> = {
  loading: 'default',
  pass: 'success',
  warning: 'warning',
  fail: 'error',
  error: 'default',
  'partial-error': 'default',
  waiting: 'default',
};

export const HealthCheckButton = forwardRef<HTMLDivElement, { status: HealthCheckOverallStatus; onPress?: () => void }>(
  ({ status, onPress }, ref) => (
    <Pressable onPress={onPress}>
      <div role="button" style={{ cursor: 'pointer' }}>
        <TagGroup aria-label={msg('healthCheck.panel.statusLabel')} ref={ref}>
          <TagList>
            <Tag
              variant={variantMap[status]}
              data-status={status}
              textValue={textMap[status]}
              className={styles.healthCheckButtonTag}
            >
              {status !== 'waiting' && (
                <div className={styles.healthCheckButtonIcon}>
                  <HealthCheckIcon status={status} />
                </div>
              )}
              <span className={styles.healthCheckButtonText}>{textMap[status]}</span>
            </Tag>
          </TagList>
        </TagGroup>
      </div>
    </Pressable>
  ),
);
